import { Paragraph2 } from '@cian/ui-kit';

import * as React from 'react';
import { CommercialOwnerIcon } from '../CommercialOwnerIcon';

export const VERIFICATION_STEP_TEXT = [
  {
    desktop: (
      <Paragraph2>
        Укажите кадастровый номер объекта и&nbsp;ИНН/ФИО собственника — в&nbsp;объявлении этих данных не&nbsp;будет
      </Paragraph2>
    ),
    mobile: (
      <Paragraph2>
        Укажите кадастровый номер объекта и&nbsp;ИНН/ФИО собственника — в&nbsp;объявлении этих данных не&nbsp;будет
      </Paragraph2>
    ),
  },
  {
    desktop: (
      <Paragraph2>
        Мы бесплатно проверим данные в&nbsp;Росреестре: если они верны, на&nbsp;объявлении появится значок
        «Проверено&nbsp;в&nbsp;Росреестре»
      </Paragraph2>
    ),
    mobile: (
      <Paragraph2 as="div">
        Мы бесплатно проверим данные в&nbsp;Росреестре: если они верны, на&nbsp;объявлении появится яркий значок{' '}
        <CommercialOwnerIcon />
      </Paragraph2>
    ),
  },
  {
    desktop: (
      <Paragraph2>
        Объявление попадёт в&nbsp;результаты поиска по&nbsp;фильтру «От&nbsp;собственника» — это может привлечь больше
        звонков
      </Paragraph2>
    ),
    mobile: <Paragraph2>Объявление попадёт в&nbsp;результаты поиска по&nbsp;фильтру «От&nbsp;собственника»</Paragraph2>,
  },
];
